import React from "react";
import L from "leaflet";
import shpwrite from "shp-write";
import wkx from "wkx";
import geojson2dsv from "geojson2dsv";
import togpx from "togpx";
import polyline from "@mapbox/polyline";
import topojson from "topojson";
import { saveAs } from "file-saver";
import tokml from "tokml";
import geojsonNormalize from "@mapbox/geojson-normalize";
import simplify from "@turf/simplify";
import wellknown from "wellknown";
import magicFile from "../lib/magic_file";
import geojsonRandom from "geojson-random";
import geojsonExtent from "geojson-extent";
import geojsonFlatten from "geojson-flatten";
import mergeGeojson from "../lib/merge_geojson";
import { awsPost } from "../aws/aws_integration";
import '../lib/vkbeautify.0.99.00.beta';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { Button } from "@material-ui/core";
import { orange } from '@material-ui/core/colors';

export default class FileBar extends React.Component {
  constructor(props) {
    super();
    this.fileInputRef = React.createRef();
  }
  blindImport = () => {
    this.fileInputRef.current.click();
  };
  onFileInputChange = async e => {
    const { files } = e.target;
    const { geojson, setGeojson } = this.props;
    const geojsons = await Promise.all([...files].map(file => {
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.addEventListener("load", () =>
          resolve(magicFile(reader.result))
        );
      });
    }));
    setGeojson(mergeGeojson([geojson, ...geojsons]));
  };
  downloadTopo = () => {
    const { geojson } = this.props;
    var content = JSON.stringify(
      topojson.topology(
        {
          collection: JSON.parse(JSON.stringify(geojson))
        },
        {
          "property-transform": function (properties, key, value) {
            properties[key] = value;
            return true;
          }
        }
      )
    );

    this.download(content, "map.topojson", "text/plain;charset=utf-8");
  };

  download = (content, filename, type) => {
    saveAs(
      new Blob([content], {
        type
      }),
      filename
    );
  };

  downloadGPX = () => {
    const { geojson } = this.props;
    this.download(
      togpx(geojson, {
        creator: "geojson.net"
      }),
      "map.gpx",
      "text/xml;charset=utf-8"
    );
  };

  downloadGeoJSON = () => {
    const { geojson } = this.props;
    this.download(
      JSON.stringify(geojson, null, 2),
      "map.geojson",
      "text/plain;charset=utf-8"
    );
  };

  downloadDSV = () => {
    const { geojson } = this.props;
    this.download(
      geojson2dsv(geojson),
      "points.csv",
      "text/plain;charset=utf-8"
    );
  };

  downloadKML = () => {
    const { geojson } = this.props;
    this.download(tokml(geojson), "map.kml", "text/plain;charset=utf-8");
  };

  downloadShp = () => {
    const { geojson } = this.props;
    shpwrite.download(geojson);
  };

  downloadWKT = () => {
    const { geojson } = this.props;
    var features = geojson.features;
    if (features.length === 0) return;
    var content = features.map(wellknown.stringify).join("\n");
    this.download(content, "map.wkt", "text/plain;charset=utf-8");
  };

  confirmSave = () => {
    if (confirm("Are you sure you want to save?")) {
      this.uploadSTX()
    }
  }

  uploadSTX = () => {

    const removeLeadingTrailingCommas = (input) => {
      str = input;
      if (str[0] === ",") str = str.substr(1);
      if (str[str.length-1] === ",") str = str.substr(0, str.length-1);

      if (str[0] === "," || str[str.length-1] === ",") return removeLeadingTrailingCommas(str);
      return str;
    }

    const { geojson, metadata } = this.props;
    let cDataJson = JSON.parse(JSON.stringify(geojson));
    for (let i = 0; i < cDataJson.features.length; i++) {
      if (cDataJson.features[i].type === "Feature") {
        const { desc, title, transcript } = cDataJson.features[i].properties;
        if (desc !== undefined) cDataJson.features[i].properties.desc = desc.includes("<![CDATA[") ? desc : "<![CDATA[" + desc + "]]>";
        if (title !== undefined) cDataJson.features[i].properties.title = title.includes("<![CDATA[") ? title : "<![CDATA[" + title + "]]>";
        if (transcript !== undefined) cDataJson.features[i].properties.transcript = transcript.includes("<![CDATA[") ? transcript : "<![CDATA[" + transcript + "]]>";
        // removing leading and trailing commas
        if (cDataJson.features[i].properties.images !== undefined) {

          cDataJson.features[i].properties.images = removeLeadingTrailingCommas(cDataJson.features[i].properties.images);
        }

        // THIS IS TEMPORARY, REMOVE AFTER APP IS UPDATED!!!!!
        if (cDataJson.features[i].properties.audioContinueOnReEntry !== undefined) {
          // if its true for whatever reason, it needs to be removed
          if (typeof cDataJson.features[i].properties.audioContinueOnReEntry === "string") {
            if (cDataJson.features[i].properties.audioContinueOnReEntry.trim() === "true") {
              delete cDataJson.features[i].properties.audioContinueOnReEntry
            }
          } else if (cDataJson.features[i].properties.audioContinueOnReEntry) {
            delete cDataJson.features[i].properties.audioContinueOnReEntry
          }
        }

      }
    }
    let meta = "";
    // Here I'm just putting the meta data back into the file
    for (const [k, v] of Object.entries(metadata)) {
      if (k === "title" || k === "desc" || k === "copyright") {
        meta += `<Data name="${k}"><value><![CDATA[${v.trim()}]]></value></Data>`;
      } else {
        meta += `<Data name="${k}"><value>${v.trim()}</value></Data>`;
      }
    }

    console.log(this.props);

    let kml = tokml(cDataJson);

    // the extended data belongs just under the document so I'm just gonna split it a insert the extended data
    let splitKML = kml.split("<Document>");
    splitKML[1] = "<ExtendedData>" + meta + "</ExtendedData>" + splitKML[1];
    kml = splitKML.join("<Document>");

    console.log("-----------PRE-----------")
    console.log(vkbeautify.xml(kml))
    console.log("-------------------------")

    kml = kml.replaceAll(/&amp;/g, "&")
    kml = kml.replaceAll(/&nbsp;/g, " ")
    kml = kml.replaceAll(/&quot;/g, "\"");
    kml = kml.replaceAll(/&gt;/g, ">");
    kml = kml.replaceAll(/&lt;/g, "<");

    console.log("-----------POS-----------")
    console.log(vkbeautify.xml(kml))
    console.log("-------------------------")

    kml = vkbeautify.xml(kml);

    kml = kml.replaceAll(/<value>\n/g, "<value>");
    kml = kml.replaceAll(/]]>\n/g, "]]>");

    // fixing up the beautifiers mistakes
    var removeSpace = kml.split("<![CDATA[");
    for (var l = 0; l < removeSpace.length; l++) {
      if (l >= removeSpace.length - 1) {
        removeSpace[l] = removeSpace[l].trimRight();
      } else {
        removeSpace[l] = removeSpace[l].trimRight() + "<![CDATA[";
      }
    }
    kml = removeSpace.reduce((previousValue, currentValue) => previousValue += currentValue)
    removeSpace = kml.split("]]>");
    for (var l = 0; l < removeSpace.length; l++) {
      if (l >= removeSpace.length - 1) {
        removeSpace[l] = removeSpace[l].trimLeft();
      } else {
        removeSpace[l] = removeSpace[l].trimLeft() + "]]>";
      }
    }
    kml = removeSpace.reduce((previousValue, currentValue) => previousValue += currentValue)
    console.log(kml)
    const blob = new Blob([kml], {
      type: "application/xml"
    });

    awsPost(blob, true).then((res) => {
      console.log(res);
      if (res.ok) {
        alert("File saved")
      } else {
        alert("Error saving file: " + res.status + " " + res.statusText)
      }

    }).catch((e) => { alert("Error saving file: " + e) });

  }

  render() {
    const { setGeojson } = this.props;
    const exportFormats = [
      {
        title: "GeoJSON",
        action: this.downloadGeoJSON
      },
      {
        title: "TopoJSON",
        action: this.downloadTopo
      },
      {
        title: "GPX",
        action: this.downloadGPX
      },
      {
        title: "CSV",
        action: this.downloadDSV
      },
      {
        title: "Shapefile",
        action: this.downloadShp
      },
      {
        title: "KML",
        action: this.downloadKML
      },
      {
        title: "WKT",
        action: this.downloadWKT
      }
    ];
    var actions = [
      {
        title: "Save",
        action: () => {
          this.confirmSave();
        }
        // children: exportFormats
      },
      {
        title: "Undo changes",
        action: () => {
          if (confirm("This will undo all changes you have made to this file.\nDo you want to proceed?")) {
            window.location.reload();
          }
        }
        // children: exportFormats
      },
      {
        title: "New",
        action: function () {
          window.open(
            window.location.origin + window.location.pathname + "#new"
          );
        }
      },
      {
        title: "Meta",
        action: function () { },
        children: [
          {
            title: "Clear",
            alt: "Delete all features from the map",
            action: () => {
              if (
                confirm(
                  "Are you sure you want to delete all features from this map?"
                )
              ) {
                setGeojson({ type: "FeatureCollection", features: [] });
              }
            }
          },
          {
            title: "Random: Points",
            alt: "Add random points to your map",
            action: () => {
              const { setGeojson, geojson } = this.props;
              var response = prompt("Number of points (default: 100)");
              if (response === null) return;
              var count = parseInt(response, 10);
              if (isNaN(count)) count = 100;
              const fc = geojsonNormalize(geojson);
              setGeojson({
                type: "FeatureCollection",
                features: fc.features.concat(
                  geojsonRandom.point(count).features
                )
              });
            }
          },
          {
            title: "Add bboxes",
            alt: "Add bounding box members to all applicable GeoJSON objects",
            action: () => {
              const { setGeojson, geojson } = this.props;
              setGeojson(geojsonExtent.bboxify(geojson));
            }
          },
          {
            title: "Simplify",
            alt: "Remove unnecessary detail from GeoJSON features",
            action: () => {
              const { setGeojson, geojson } = this.props;
              setGeojson(simplify(geojson));
            }
          },
          {
            title: "Flatten Multi Features",
            alt:
              "Flatten MultiPolygons, MultiLines, and GeometryCollections into simple geometries",
            action: () => {
              const { setGeojson, geojson } = this.props;
              setGeojson(geojsonFlatten(geojson));
            }
          },
          // https://developers.google.com/maps/documentation/utilities/polylinealgorithm
          {
            title: "Load encoded polyline",
            alt:
              "Decode and show an encoded polyline. Precision 5 is supported.",
            action: () => {
              const { setGeojson } = this.props;
              const input = prompt("Enter your polyline");
              try {
                const decoded = polyline.toGeoJSON(input);
                setGeojson(decoded);
              } catch (e) {
                alert("Sorry, we were unable to decode that polyline");
              }
            }
          },
          {
            title: "Load WKB Base64 Encoded String",
            alt: "Decode and show WKX data",
            action: () => {
              const input = prompt("Enter your Base64 encoded WKB/EWKB");
              try {
                // TODO: base64 in browser
                var decoded = wkx.Geometry.parse(Buffer.from(input, "base64"));
                setGeojson(decoded.toGeoJSON());
                // zoomextent(context); TODO
              } catch (e) {
                console.error(e);
                alert(
                  "Sorry, we were unable to decode that Base64 encoded WKX data"
                );
              }
            }
          },
          {
            title: "Load WKB Hex Encoded String",
            alt: "Decode and show WKX data",
            action: function () {
              const input = prompt("Enter your Hex encoded WKB/EWKB");
              try {
                var decoded = wkx.Geometry.parse(Buffer.from(input, "hex"));
                setGeojson(decoded.toGeoJSON());
                // zoomextent(context); TODO
              } catch (e) {
                console.error(e);
                alert(
                  "Sorry, we were unable to decode that Hex encoded WKX data"
                );
              }
            }
          },
          {
            title: "Load WKT String",
            alt: "Decode and show WKX data",
            action: function () {
              const input = prompt("Enter your WKT/EWKT String");
              try {
                var decoded = wkx.Geometry.parse(input);
                setGeojson(decoded.toGeoJSON());
                // zoomextent(context); TODO
              } catch (e) {
                console.error(e);
                alert("Sorry, we were unable to decode that WKT data");
              }
            }
          }
        ]
      }
    ];

    if (!window.location.search.includes("stx")) {
      actions.unshift({
        title: "Open",
        children: [
          {
            title: "File",
            alt: "GeoJSON, TopoJSON, GTFS, KML, CSV, GPX and OSM XML supported",
            action: this.blindImport
          },
          ,
          /*{
            title: "Gist",
            alt: "GeoJSON files in GitHub Gists",
            authenticated: true,
            action: this.props.toggleGistModal
          }*/
          {
            title: "GitHub",
            alt: "GeoJSON files in GitHub Repositories",
            authenticated: true,
            action: this.props.toggleGithubModal
          }
        ]
      });
    } else {
      actions = [actions[0]];
    }

    const theme = createMuiTheme({
        palette: {
            primary: orange,
        },
    });

    return (
      <div className="bg-white flex justify-between bb" style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ marginLeft: "12px", marginTop: "14px", marginBottom: "0px" }}>{this.props.metadata.title}</h2>
        <div className="inline-flex">
          {actions.map((item, i) => {
            return (
              <ThemeProvider theme={theme}>
                <Button
                  variant="contained"
                  onClick={item.action}
                  color="primary"
                  style={{ margin: "8px" }}
                >
                  {item.title}
                </Button>
              </ThemeProvider>
            );
          })}
          <input
            type="file"
            className="dn"
            multiple
            ref={this.fileInputRef}
            onChange={this.onFileInputChange}
          />
        </div>
      </div>
    );
  }
}
